import { useState } from "react"
import { Navbar2 } from "./elements/navbar"
import SiteGreeter from "./elements/site-greeter"
import Footer from "./elements/footer"
import NotificationBanner from "./elements/notification-banner"
import OfferPopupBanner from "./elements/offer-popup-banner"
import clsx from "clsx"
import { HeaderHeightProvider } from "./context/header-height-provider"


export default function Layout({ children, global, isLandingPage = false }) {
  const { navbar, footer, notificationBanner, currentOffer } = global.attributes
  const [bannerIsShown, setBannerIsShown] = useState(true)

  return (
    <>
      <HeaderHeightProvider>
        {(headerRef, headerHeight) =>  {
          return (
          <div className="min-h-screen bg-[#fffaeb] text-[#3f2415] antialiased">
            {/* Aligned to the top */}
            <header ref={headerRef} className="fixed inset-x-0 top-0 z-50">
              {/* Card background */}
              {/* <div className="mt-3 rounded-2xl border border-[#e0b15e]/35 bg-white/70 shadow-sm backdrop-blur"> */}
              <div>
                {notificationBanner && bannerIsShown && (
                  <NotificationBanner
                    data={notificationBanner}
                    closeSelf={() => setBannerIsShown(false)}
                  />
                )}
                <Navbar2 navbar={navbar} pageContext={global.attributes.pageContext} />
                
              </div>

              
              {/* { currentOffer && <OfferPopupBanner 
                enabled 
                offerId={currentOffer?.id || "default-offer"}
                repeatDaily 
                topOffsetPx={headerHeight} 
                headline={currentOffer?.headline || "This Week’s Offer"}
                subheadline={currentOffer?.subheadline || "Surprise Minis"}
                body={currentOffer?.body || "Enjoy free minis with your purchase! One mini per $"}
                hero={currentOffer?.hero || { src: "/images/offers/surprise-mini-hero.jpg", alt: "Surprise Minis" }} 
                ctaLabel={currentOffer?.ctaLabel || "Shop the offer"} 
                cta={{ kind: currentOffer?.cta?.kind || "link", href: currentOffer?.cta?.href || "/store" }} 
                stickyText={currentOffer?.stickyText || "This Week’s Offer: Surprise Minis"} /> }

              { !currentOffer && <OfferPopupBanner 
                enabled 
                offerId="january-2026-offer"
                repeatDaily 
                topOffsetPx={headerHeight} 
                headline="It's Citrus Season!"
                subheadline= "Get a lemon or orange mini with any purchase"
                body="Free Shipping on 6 Packs, normally $5.99 AND We are adding a citrus mini in every order"
                hero={{}}
                ctaLabel="Shop Assortment 6 Pack Use Code: FLORIDA2026"
                cta={{ kind:"link", href: "/store/Marshmallow-Crispy-Assortment-6-Pack-p746961114" }} 
                stickyText="Free Shipping on 6 Packs + Free Mini for All" /> } */}

            </header>

            {/* <main className={clsx("relative", staatliches.className, pacifico.className, lato.className)}> */}
            <main className={clsx("relative")} style={{ paddingTop: `${headerHeight}px` }}>
              <SiteGreeter global={global} />
            <div className="mx-auto w-full max-w-6xl">
                {children}
              </div>
            </main>

            {/* Aligned to the bottom */}
            {!isLandingPage && (
              <div className="mx-auto w-full max-w-6xl">
                <Footer footer={footer} locale={global.attributes.pageContext?.locale} />
              </div>
            )}
          </div>
        )}}
      </HeaderHeightProvider>
    </>
  )
}
